<template>
    <el-dialog fullscreen class="global-dialog"
            title="取色工具"
            :visible.sync="visible">
        <div class="canvas-box">
            <div class="canvas-hover">
                <div ref="canvasDom"></div>
                <div class="mouse-position" :style="calcMousePositionStyle">
                    <div class="mp-bg-color" :style="{backgroundColor: bgColor}"></div>
                    <div class="mp-bg-value">{{bgColor}}</div>
                </div>
            </div>
            <div style="height: 0px;overflow: auto">
                <div :style="getImgWidth" ref="imgDom" >
                    <img :src="url"/>
                </div>
            </div>
        </div>
    </el-dialog>
</template>
<script>
    import util from '@/util.js';
    export default {
        props:{
            value: {type: Boolean, default: false},
            url: String
        },
        data(){
            return {
                left: null,
                top: null,
                bgColor: '',
                show: false,
                img:{
                    width: 0,
                    height: 0
                }
            }
        },
        watch:{
            url(){
                this.init()
            },
        },
        computed: {
            visible:{
                get(){
                    return this.value;
                },
                set(v){
                    this.$emit('input', v);
                }
            },
            calcMousePositionStyle(){
                if(!this.show){
                    return 'display:none';
                }
                return `left: ${this.left}px;top: ${this.top}px;`;
            },
            getImgWidth(){
                return `width: ${this.img.width}px;height: ${this.img.height}px`;
            },
        },
        methods:{
            init(){
                if(!this.url){
                    return;
                }
                let img = new Image();
                img.src = this.url;
                img.onload = () => {
                    this.img.width = img.width;
                    this.img.height = img.height;
                    this.$nextTick(() => {
                        let imgDom = this.$refs.imgDom;
                        util.html2canvas(imgDom, img.width, img.height).then((canvas) => {
                            this.cleanCanvas();
                            this.$refs.canvasDom.appendChild(canvas);
                            this.initEvent(canvas);
                        });
                    })
                }
            },
            cleanCanvas(){
                if(this.$refs.canvasDom){
                    this.$refs.canvasDom.innerHTML = null;
                }
            },
            initEvent(canvasDom){
                canvasDom.addEventListener('mousemove', (e) => {
                    let scale = window.devicePixelRatio || 1; //苹果高清本上，图片的像素 = 原像素 x window.devicePixelRatio
                    let canvasX = e.offsetX * scale;
                    let canvasY = e.offsetY * scale;
                    let colorData = canvasDom.getPixelColor(canvasX, canvasY);
                    let color = colorData.rgba;
                    requestAnimationFrame(() => {
                        this.left = e.pageX;
                        this.top =  e.pageY;
                        this.bgColor =  color;
                        this.show = true;
                    });
                })
                canvasDom.addEventListener('click', () => {
                    this.$emit('change', this.bgColor);
                    this.visible = false;
                });
            }
        }
    }
</script>
<style lang="scss">
    @import "./index.scss";
</style>